import React from 'react';
import styles from "../schedulePOComps/Potable.module.css";
import { Package, Layers } from 'lucide-react';

const OrderTable = ({ data = [] }) => {
    const formatPrice = (val) => {
        const num = Number(val) || 0;
        return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    return (
        <div className={styles.previewContainer}>
            <div className={styles.tableHeaderBar}>
                <h3 className={styles.tableTitle}>
                    <Layers size={18} color="#512DA8" />
                    Ordered Items
                </h3>
                <span className={styles.itemCountBadge}>
                    {data?.length || 0} {data?.length === 1 ? 'Item' : 'Items'}
                </span>
            </div>

            <table className={styles.previewtable}>
                <thead>
                    <tr>
                        <th className={styles.previewth} style={{ width: '35%' }}>Part Details</th>
                        <th className={styles.previewth} style={{ width: '20%' }}>Manufacturer</th>
                        <th className={styles.previewth} style={{ width: '15%' }}>Quantity</th>
                        <th className={styles.previewth} style={{ width: '15%' }}>Unit Price</th>
                        <th className={styles.previewth} style={{ width: '15%', textAlign: 'right' }}>Subtotal</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data.length > 0 ? (
                        data.map((item, index) => {
                            const partNo = item?.productId?.productOverview?.productNumber?.[0] || '-';
                            const manufacturerName = item?.productId?.productOverview?.manufacturer?.[0]?.name || '-';
                            const imgSrc = item?.productId?.assets?.image?.[0];
                            const unitPrice = item?.unitPrice || 0;
                            const subtotal = (item?.quantity || 0) * unitPrice;
                            const sku = item?.productId?._id ? `#${item.productId._id.slice(-6)}` : `Item ${index + 1}`;

                            return (
                                <tr key={item?.id || item?._id || index} className={styles.previewstripedRow}>
                                    <td className={styles.previewtd}>
                                        <div className={styles.productCell}>
                                            <div className={styles.productImgBox}>
                                                {imgSrc ? (
                                                    <img 
                                                        src={imgSrc} 
                                                        alt={partNo}
                                                        className={styles.productImg}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.style.display = 'none';
                                                            e.target.nextSibling.style.display = 'flex';
                                                        }}
                                                    />
                                                ) : null}
                                                <div 
                                                    style={{ 
                                                        display: imgSrc ? 'none' : 'flex', 
                                                        color: '#94A3B8',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <Package size={22} />
                                                </div>
                                            </div>
                                            <div className={styles.productInfoWrap}>
                                                <span className={styles.partNumberText}>{partNo}</span>
                                                <span className={styles.skuText}>SKU: {sku}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className={styles.previewtd}>
                                        <span className={styles.manufacturerBadge}>{manufacturerName}</span>
                                    </td>
                                    <td className={styles.previewtd}>
                                        <span className={styles.quantityBadge}>{item?.quantity?.toLocaleString('en-IN') || 0}</span>
                                    </td>
                                    <td className={styles.previewtd}>
                                        <span className={styles.unitPriceText}>{formatPrice(unitPrice)}</span>
                                    </td>
                                    <td className={styles.previewtd} style={{ textAlign: 'right' }}>
                                        <span className={styles.subtotalText}>{formatPrice(subtotal)}</span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: 'center', padding: '36px 20px', color: '#64748B' }}>
                                <Package size={28} style={{ margin: '0 auto 8px', color: '#CBD5E1', display: 'block' }} />
                                No ordered products found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default OrderTable;